<template>
	<div class="app-text-tooltip">
		<v-tooltip top v-bind="$attrs">
			<template v-slot:activator="{ on, attrs }">
				<div v-bind="attrs" v-on="on">
					<slot />
				</div>
			</template>
			<span v-html="tooltipText" />
		</v-tooltip>
	</div>
</template>

<script>
export default {
	name: 'AppTextTooltip',
	props: {
		tooltipText: { type: String },
	},
};
</script>

<style scoped lang="scss">
.app-text-tooltip {
	::v-deep div[role='button'] {
		cursor: default;
	}
}
</style>
